export default __webpack_public_path__ + "static/media/thumbnail.a8005623.png";